import { createAsyncThunk } from '@reduxjs/toolkit';

import { AdminApiPaths, APIDataProvider, TApiResponse } from '../../../api';
import { IManualAdjustment } from '.';

export type TAdminCreateManualAdjustment = {
  tutorId: string;
  date: string;
  title: string;
  descritpion: string;
  amount: number;
  currency: string;
  isPaid?: boolean;
};

export type TAdminGetManualAdjustments = {
  limit: number;
  offset: number;
  sortKey?: string;
  sortValue?: number;
  startDate?: string;
  endDate?: string;
  tutorId?: string;
};

const apiDataProvider = new APIDataProvider();

const adminGetManualAdjustmentsModule = async ({
  limit,
  offset,
  sortKey,
  sortValue,
  startDate,
  endDate,
  tutorId,
}: TAdminGetManualAdjustments) => {
  let path = `${AdminApiPaths.manualAdjustments}?limit=${limit}&offset=${offset}`;

  if (sortKey) {
    path += `&sortKey=${sortKey}`;
  }

  if (sortValue) {
    path += `&sortValue=${sortValue}`;
  }

  if (startDate) {
    path += `&startDate=${startDate}`;
  }

  if (endDate) {
    path += `&endDate=${endDate}`;
  }

  if (tutorId) {
    path += `&tutorId=${tutorId}`;
  }

  const response = await apiDataProvider.get<
    TApiResponse<{
      offset: number;
      limit: number;
      totalDocs: number;
      docs: Array<IManualAdjustment>;
    }>
  >(path);

  return response.data;
};

export const adminCreateManualAdjustment = createAsyncThunk(
  '/admin/manual-adjustments/create',
  async (data: TAdminCreateManualAdjustment) => {
    const response = await apiDataProvider.post<
      TApiResponse<IManualAdjustment>
    >(`${AdminApiPaths.manualAdjustments}`, data);

    return response.data;
  }
);

export const adminGetManualAdjustments = createAsyncThunk(
  '/admin/manual-adjustments/list',
  adminGetManualAdjustmentsModule
);
